import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface StatCardSkeletonProps {
  background?: string; // Background color for the skeleton
  withChart?: boolean;
  withIcon?: boolean;
}

const StatCardSkeleton: React.FC<StatCardSkeletonProps> = ({
  background = 'white',
  withChart = false,
  withIcon = false,
}) => {
  return (
    <Box
      py={4}
      px={4}
      rounded="xl"
      shadow="card"
      border="1px solid"
      borderColor="light-gray-2"
      bg={background}
      height="100%"
      w="full"
    >
      {/* Header with title and optional icon */}
      <HStack justify="space-between" mb={3}>
        <Skeleton height="16px" width="120px" />
        {withIcon && <Skeleton height="16px" width="16px" />}
      </HStack>

      {/* Main content area */}
      <Flex justify="space-between" align="end">
        <VStack alignItems="start" gap={2} flex={1}>
          {/* Main Value */}
          <Skeleton height="32px" width="140px" />

          {/* Comparison and Percentage Change */}
          <HStack gap={2} alignItems="center">
            <Skeleton height="14px" width="80px" />
            <Skeleton height="20px" width="50px" />
          </HStack>
        </VStack>

        {/* Chart - right side */}
        {withChart && (
          <Box h="40px" w="120px" ml={4}>
            <Skeleton height="40px" width="120px" rounded="md" />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default StatCardSkeleton;
